module.exports = __webpack_public_path__ + "static/img/3432678.c462815.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/3432678.svg
// module id = KF7f
// module chunks = 1